import React from "react";

const AssetDropZone = ({ visible = false }) => {
  const iconStyle = {
    marginRight: "0.25em",
  };

  const style = {
    position: "fixed",
  };

  const areaStyle = {
    top: 40,
    bottom: 40,
    left: 40,
    right: 40,
    position: "absolute",
    margin: 0,
  };

  const classes = `drop-zone ${visible ? "hover" : ""}`;

  return (
    <div className={classes} style={style}>
      <div className={"instrux"} style={areaStyle}>
        <span className={"glyphicon glyphicon-circle_plus"} style={iconStyle}></span> Drop files
        here
      </div>
    </div>
  );
};

export default AssetDropZone;
